import { render } from "./P100.vue?vue&type=template&id=4a8536a5&scoped=true"
import script from "./P100.vue?vue&type=script&lang=js"
export * from "./P100.vue?vue&type=script&lang=js"

import "./P100.vue?vue&type=style&index=0&id=4a8536a5&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8536a5"]])

export default __exports__